import React from 'react';
import EventStats from '../../models/EventStats';
import Event from '../../models/Event';
import { EventQuestionType } from '../../models/EventQuestionType';

export class DeetBox extends React.Component {

  renderCreatorBox = () => {
    const { event, eventStats } = this.props;
    const isOpenEnded = EventQuestionType.isOpenEndedType(Event.getQuestionType(event));
    const responderCount = EventStats.getResponderCount(eventStats);
    const viewerCount = EventStats.getViewedUserCount(eventStats)
    const responseCount = isOpenEnded ? EventStats.getResponseCount(eventStats): EventStats.getChoicesCount(eventStats);
    const likeCount = EventStats.getIdeaLikeCount(eventStats) + EventStats.getCommentLikeCount(eventStats);
    const commentCount = EventStats.getCommentCount(eventStats);
    const votingMode = Event.getVotingMode(event);
    return (
      <div className="container p-3">
        <div className="row">
          <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 metric rounded m-1 p-3 bg-light">
            <div className="row">
              <div className="col-6">
                <div className="metric-label text-truncate">Viewed</div>
                <div className="metric-value">
                  <i className="material-icons">person</i>
                  {viewerCount}
                </div>
              </div>
              <div className="col-6">
                <div className="metric-label text-truncate">Responded</div>
                <div className="metric-value">
                  <i className="material-icons">how_to_vote</i>
                  {responderCount}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-1 col-md-0 col-sm-0">
          </div>

          <div className="col-xl-6 col-md-12 col-sm-12 metric rounded m-1 p-3 bg-light">
            <div className="row">
              <div className="col-4">
                <div className="metric-label text-truncate">{isOpenEnded ? 'Responses' : 'Choices' }</div>
                <div className="metric-value">
                  <i className="material-icons response">wb_incandescent</i>
                  {responseCount}
                </div>
              </div>

            { votingMode !== 'star-rating' &&
              <div className="col-4">
                <div className="metric-label text-truncate">Likes</div>
                <div className="metric-value">
                  <i className="material-icons like">thumb_up</i>
                  {likeCount}
                </div>
              </div>
            }

              {/* <div className="col-4">
                <div className="metric-label text-truncate">Votes</div>
                <div className="metric-value">
                  {votingMode === 'star-rating' ?
                    <>
                      <i className="material-icons rating">star</i>
                      {likeCount}
                    </>
                    :
                    <>
                      <i className="material-icons like">thumb_up</i>
                      {likeCount}
                    </>
                  }
                </div>
              </div> */}

              <div className="col-4">
                <div className="metric-label text-truncate">Comments</div>
                <div className="metric-value">
                  <img alt="Comment icon" width="24" src="/static/media/comment_blue.37fbdbfe.svg"/>
                  {commentCount}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderParticipantBox = () => {
    return null;
  };

  render () {
    const { event, eventStats } = this.props;
    if (!eventStats || !event) {
      return null;
    }

    if (Event.isUserCreated(event)) {
      return this.renderCreatorBox();
    } else {
      return this.renderParticipantBox();
    }

  }
}